module.exports = __webpack_public_path__ + "static/img/banner1.101414ce.jpg";